import { render, staticRenderFns } from "./QuestionScoringModal.vue?vue&type=template&id=222e828e&scoped=true"
import script from "./QuestionScoringModal.vue?vue&type=script&lang=js"
export * from "./QuestionScoringModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionScoringModal.vue?vue&type=style&index=0&id=222e828e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222e828e",
  null
  
)

export default component.exports